import { render, staticRenderFns } from "./dpWalletRecord.vue?vue&type=template&id=a9de4290&scoped=true"
import script from "./dpWalletRecord.vue?vue&type=script&lang=js"
export * from "./dpWalletRecord.vue?vue&type=script&lang=js"
import style0 from "./dpWalletRecord.vue?vue&type=style&index=0&id=a9de4290&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9de4290",
  null
  
)

export default component.exports